import { AbstractModel } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { TaxDocumentType } from './tax-document-type';

@inheritSerialization(AbstractModel)
export class TaxDocument extends AbstractModel {

  @autoserialize
  id: number;

  @autoserialize
  driverId: number;

  @autoserializeAs(TaxDocumentType)
  taxDocumentType: TaxDocumentType;

  @autoserialize
  taxYear: number;

  @autoserialize
  filename: string;

  @autoserialize
  filePassword: string;

  @autoserializeAs(Date)
  firstNotifiedDate: Date;

  @autoserializeAs(Date)
  firstAccessedDate: Date;
}
